<div class="lib-navigation-wrapper">
  <div class="lib-navigation-shell">
    <p-panelMenu [model]="items()" class="lib-navigation-menu"></p-panelMenu>
  </div>
</div>
